import React from 'react';

const STATUS_COLOR = {
  'Available':  'var(--success)',
  'En route':   'var(--accent)',
  'On site':    'var(--warning)',
  'On break':   'var(--text-muted)',
};

function getInitials(name) {
  return name.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase();
}

function UtilizationBar({ value }) {
  const isHigh     = value >= 85;
  const isMedium   = value >= 65;
  const fillClass  = isHigh ? 'is-critical' : isMedium ? 'is-high' : '';

  return (
    <div className="dispatch-utilization">
      <span className="dispatch-utilization-pct">{value}%</span>
      <div className="dispatch-utilization-bar" role="meter" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100}>
        <div
          className={`dispatch-utilization-fill ${fillClass}`}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}

export function TechnicianPanel({ technicians }) {
  return (
    <div className="dispatch-pane">
      <div className="dispatch-pane-header">
        <span className="dispatch-pane-title">Technicians</span>
        <span className="dispatch-pane-count">{technicians.length}</span>
      </div>
      <ul className="dispatch-tech-list" role="list">
        {technicians.map((tech) => (
          <li key={tech.id} className="dispatch-tech-item">
            <div className="dispatch-tech-avatar" aria-hidden="true">
              {getInitials(tech.name)}
            </div>
            <div className="dispatch-tech-info">
              <h3 className="dispatch-tech-name">{tech.name}</h3>
              <p
                className="dispatch-tech-status"
                style={{ color: STATUS_COLOR[tech.status] ?? 'var(--text-muted)' }}
              >
                {tech.status}
              </p>
            </div>
            <UtilizationBar value={tech.utilization} />
          </li>
        ))}
      </ul>
    </div>
  );
}
